import { createStoreWithProducer } from '@xstate/store';
import { produce } from 'immer';

import { RecordingState } from '@eluve/vendor';

export type RecordingStoreContext = {
  recordingState: RecordingState | null;
  userPresenceCheck: {
    isChecking: boolean;
    userPresenceResponseWindowMs: number;
  } | null;
};

const defaultContext: RecordingStoreContext = {
  recordingState: null,
  userPresenceCheck: null,
};

export const recordingStore = createStoreWithProducer(produce, defaultContext, {
  setRecordingState: (context, event: { state: RecordingState }) => {
    context.recordingState = event.state;
  },
  clearRecordingState: (context) => {
    context.recordingState = null;
  },
  setUserPresenceCheck: (
    context,
    event: { userPresenceResponseWindowMs: number },
  ) => {
    context.userPresenceCheck = {
      isChecking: true,
      userPresenceResponseWindowMs: event.userPresenceResponseWindowMs,
    };
  },
  clearUserPresenceCheck: (context) => {
    context.userPresenceCheck = null;
  },
});
